export const save = (key: string, value: any) => {
  localStorage[key] = value;
};

export const get = (key: string) => {
  return localStorage[key];
};

export const saveByUser = (key: string, userId: string, value: any) => {
  save(key + userId, value);
};

export const getByUser = (key: string, userId: string) => {
  return get(key + userId);
};

export default {
  save,
  get,
  saveByUser,
  getByUser
};
